module.exports = __webpack_public_path__ + "static/media/small-pj-plus.d0ed1c1d.svg";